module.exports = __webpack_public_path__ + "img/30.578d3a6b.png";